module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// SitePage_Faq

(function (fox) {
	 "use strict";
	fox.registerWidget('Promo_Faq', {

		configure: function () {

			if (!fox.objectGet(fox.i18n, 'lang') && !fox.objectGet(fox.i18n, 'defaultLang')) {
				fox.i18n = {};
				fox.i18n.lang = 'en';
			}

			this._blockPrefix = 'faqblock-';
			this._loadedLang = fox.i18n.lang;

			this.registerOptions('', {
				//container: '.promo-page-container',
				template: 'promo_faq',
				titleFaq: '',
				widgets: {
					main: {
						widget: 'Widget',
						autoRender: true,
						container: '.main-block',
						template: 'faq_main',
						group: 'faq',
						widgets: {
							dlFaq: {
								widget: 'Datalayer',
								method: 'faq.get',
								fields: ['id', 'title', 'contents.content', 'tags.title', 'tags.isTop'],
								transitParameters: {
									status: 2,
									lang: fox.i18n.lang
								}
							}
						}
					},

					result: {
						widget: 'Widget',
						autoRender: true,
						container: '.main-block',
						template: 'faq_result',
						group: 'faq',
						active: false,

						widgets: {
							searchDl: {
								widget: 'Datalayer',
								fields: ['id', 'title', 'contents.content'],
								transitParameters: {
									status: 2,
									lang: fox.i18n.lang
								},
								limit: 10
							},

							searchResult: {
								widget: 'Grid',
								autoRender: true,
								dataLayer: '@parent #searchDl',
								externalLoad: true,
								container: '.exp-block.result',
								template: 'faq_search_result',
								list: {
									container: '.fqb-list',
									'tpl.row': 'faq_post_item',
									'tpl.emptyRow': 'faq_search_nodata'
								}
							}
						}
					},

					tags: {
						widget: 'Widget',
						autoRender: true,
						container: '.fq-block.tags',
						template: 'faq_tags',
						widgets: {
							list: {
								widget: 'List',
								autoRender: true,
								container: '.fqb-tags-list',
								'tpl.row': 'faq_tags_item'
							}
						}
					},
					askQuestion: {
						widget: 'Faq_Question',
						autoRender: true,
						container: '.fq-block.ask',
						template: 'faq_question'
					}
				},

				handleWom: {
					showTag: {
						widget: fox.Navigator,
						event: 'modified_tag',
						callback: '_handleTagChange'
					},

					handleResultWidgetActivation: {
						widget: '@this',
						event: ['backLinkAvailable', 'backLinkUnavailable'],
						callback: '_handleSwitch'
					},

					handleSearchDlLoad: {
						widget: '#result #searchDl',
						event: 'loaded',
						callback: '_handleSearchDlLoad'
					},

					handleLangSwitch: {
						widget: '@root ~.Promo_Header #langSwitcher',
						event: 'langSwitched',
						callback: '_switchLang'
					},

					handleFaqLoad: {
						event: 'loaded',
						widget: '#main #dlFaq',
						callback: '_handleFaqLoaded'
					}
				},

				handleDom: {
					searchHandler: {
						target: '.fq-search-input',
						event: 'input',
						callback: '_handleSearch'
					},
					backLinkHandler: {
						target: '.back-link',
						event: 'click',
						callback: '_handleBackLink'
					},
					toggleItemVisibility: {
						targetWidget: '~.Grid #list',
						target: '.toggle',
						event: 'click',
						callback: '_toggleItemVisibility'
					},
					toggleAllItemsVisibility: {
						targetWidget: '~.Grid',
						target: '.exp',
						event: 'click',
						callback: '_toggleAllItemsVisibility'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		running: function () {

			this.templateOptions = {
				titleFaq: this.options.titleFaq
			};

			this._handleTagChange();
			this.callParent('running', arguments);
		},

		activate: function () {
			if (this._loadedLang !== fox.i18n.lang) {
				fox.each(Object.keys(this.wom1('#main').options.widgets), function (w) {
					if (w.lastIndexOf(this._blockPrefix, 0) === 0) {
						this.wom1('#main #' + w)._readyToEmbed = false;
					}
				}, this);
				this.wom1('#result #searchResult')._readyToEmbed = false;
				this.wom1('#tags #list')._readyToEmbed = false;
			}

			this._handleTagChange();
			this._switchLang();
			this.callParent('activate', arguments);
		},

		_handleFaqLoaded: function(obj, dl) {
			var posts = dl.getCollection(),
				postsByTag = {top: {}, usual: {}},
				tags = [];

			for (var i = 0; i < posts.length; i++) {
				var post = posts[i];
				if (!fox.isEmpty(post.tags.collection)) {
					for (var tag in post.tags.collection) {
						var title = post.tags.collection[tag].title,
							isTop = post.tags.collection[tag].isTop,
							group = isTop ? 'top' : 'usual';

						if (!postsByTag[group].hasOwnProperty(title)) {
							postsByTag[group][title] = [];
							tags.push({alias: title});
						}

						postsByTag[group][title].push(post);
					}
				}
			}

			this._renderFaqs(postsByTag);
			this._renderCategories(tags);
		},

		_renderFaqs: function(postsByTag) {
			var main = this.wom1('#main');
			var groupOrder = ['top', 'usual'];
			var i;

			fox.each(Object.keys(main.options.widgets), function(w) {
				if (w.lastIndexOf(this._blockPrefix, 0) === 0) {
					this.wom1('#main #' + w).removeFromDom();
					main.removeEmbeddedWidget(w);
				}
			}, this);

			function _renderBlock (posts, tag) {
				var tagHash = new Date().getTime() + '_' + parseInt(Math.random()*10000000);
				var faqBlock = main.embedWidget(this._blockPrefix + tagHash, 'Widget', {
					autoRender: true,
					container: '.faqs',
					template: 'faq_block',
					'embed.location': 'lastChild',
					handleDom: {
						toggleAllItemsVisibility: {
							target: '.exp',
							event: 'click',
							callback: fox.bind(this._toggleAllItemsVisibility, this)
						}
					}
				});

				faqBlock.setTemplateOptions({
					title: tag,
					alias: this._blockPrefix + tagHash,
					isTop: groupOrder[i] === 'top'
				});

				faqBlock.embedWidget('list', 'List', {
					autoRender: true,
					container: '.fqb-list',
					'tpl.row': 'faq_post_item',
					'tpl.emptyRow': 'faq_nodata',
					collection: posts,
					handleDom: {
						toggleItemVisibility: {
							target: '.toggle',
							event: 'click',
							callback: fox.bind(this._toggleItemVisibility, this)
						}
					}
				});

				faqBlock.run();
			}

			for (i=0; i < groupOrder.length; i++) {
				fox.each(postsByTag[groupOrder[i]], _renderBlock, this);
			}
		},

		_renderCategories: function(categories) {
			var tagsList = this.wom1('#tags #list');
			tagsList.setCollection(categories);

			if (!tagsList._readyToEmbed) {
				tagsList._readyToEmbed = true;
				tagsList.render();
			}
		},

		_toggleItemVisibility: function (el, alias, w, e) {
			el = fox.dom.wrap(el);
			var isOpened = el.hasClass('opened');

			el[(isOpened ? 'removeClass' : 'addClass')]('opened');
		},

		_toggleAllItemsVisibility: function (el, ev,  w) {
			var alias = w.getAlias();
			var block = fox.dom.selectFirst('.fqb-list[data-alias="' + alias + '"]', this.element);
			var txtBlock = fox.dom.selectFirst('.txt', el);

			if (!block) {
				return;
			}

			var items = fox.dom.select('.toggle', block);
			var isOpened = fox.dom.hasClass('opened', block);
			var operation = (isOpened ? 'removeClass' : 'addClass');
			var txt = (isOpened ? 'Expand all' : 'Collapse all');

			fox.each(items, function (item) {
				fox.dom[operation]('opened', item);
			}, this);

			fox.dom[operation]('opened', block);
			fox.dom[operation]('opened', el);
			txtBlock.innerHTML = txt;
		},

		_handleTagChange: function () {
			var tag = fox.Navigator.get('tag');
			
			if (!tag) {
				this.showAllArticles(true);
				return;
			}

			this.showArticlesByTag(tag);
		},

		showAllArticles: function (dnReload) {
			var w = this.wom1('#main');

			if (!w) {
				return;
			}

			this.wom1('#main #dlFaq').load(dnReload);

			this.switchEmbeddedWidget('main');
			this._isAllShowed = true;
			this.dispatchEvent('backLinkUnavailable');
		},

		showArticlesByTag: function (tag) {
			var w = this.wom1('#result');

			if (!w) {
				return;
			}

			this.wom1('#result #searchResult')._readyToEmbed = false;

			var dl = w.rwom1('#searchDl');
			dl.setMethod('faq.get');
			dl.setTransitParameter('tags', tag);
			dl.setTransitParameter('lang', fox.i18n.lang);
			dl.load();

			this.switchEmbeddedWidget('result');
			this.dispatchEvent('backLinkAvailable');
			this._isAllShowed = false;
		},

		_handleSwitch: function (obj, w, ev) {
			var state = ev === 'backLinkAvailable';
			if (this.isEmbedded()) {
				this.toggleBackLink(state);
			} else {
				this.wait('addedToDom').then(function () {
					this.toggleBackLink(state);
				}.bind(this));
			}
		},

		toggleBackLink: function (state) {
			if (this.element) {
				var link = fox.dom.selectFirst('.back-link', this.element[0]);

				if (!link) {
					return;
				}

				fox.dom[(state ? 'addClass' : 'removeClass')]('show', link);
			}
		},

		_handleSearch: function (el) {
			if (this._searchTimeout) {
				clearTimeout(this._searchTimeout);
			}

			if (!el.value.length && !this._isAllShowed) {
				this.showAllArticles(true);
				return;
			}

			if (el.value.length >= 3) {
				this._searchTimeout = setTimeout(function() { this.search(el.value); }.bind(this), 1000);
			}
		},

		search: function (str) {
			this.wom1('#result #searchResult')._readyToEmbed = false;

			var dl = this.rwom1('#result #searchDl');
			dl.setMethod('faq.searchPost');
			dl.setTransitParameter('phrase', str);
			dl.setTransitParameter('lang', fox.i18n.lang);
			dl.load();

			this.switchEmbeddedWidget('result');
			this.dispatchEvent('backLinkAvailable');
			this._isAllShowed = false;
		},

		_handleBackLink: function () {
			if (!this._isAllShowed) {
				this.showAllArticles(true);
			}

			fox.site.gotoPage('faq');
		},

		_switchLang: function() {
			if (this._loadedLang !== fox.i18n.lang) {
				this.wom1('#main #dlFaq').setTransitParameter('lang', fox.i18n.lang);
				this.wom1('#result #searchDl').setTransitParameter('lang', fox.i18n.lang);

				if (this._isAllShowed) {
					this.wom1('#main #dlFaq').load();
				} else {
					this.wom1('#result #searchDl').load();
				}

				this._loadedLang = fox.i18n.lang;
			}
		},

		_handleSearchDlLoad: function() {
			var resultGrid = this.wom1('#result #searchResult');

			if (!resultGrid._readyToEmbed) {
				resultGrid._readyToEmbed = true;
				resultGrid.render();
			}
		}
	});

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/faq/widget/faq.js
// module id = 495
// module chunks = 2